export default "__VITE_ASSET__BU88BDuq__"